import { Namespace } from 'enums-lib';

export const TR1_CONTACT_DOCUMENT_SOURCE_TYPE = 'TR1_CONTACT_DOCUMENT';

interface IContactDocument {
  id: string;
  name: string;
  type: string;
  size?: number;
  origin?: string;
  downloadUrl?: string;
  contentType?: string;
  fileExtension?: string;
}

export function buildSalesforceContactDocumentParameters(
  namespace: string | undefined,
  file: IContactDocument
): Record<string, any> | undefined {
  if (namespace !== Namespace.salesforce) {
    return undefined;
  }

  if (file.origin !== 'ContactDocument' || !file.downloadUrl) {
    return undefined;
  }

  return {
    sourceType: TR1_CONTACT_DOCUMENT_SOURCE_TYPE,
    downloadUrl: file.downloadUrl,
    fileName: file.name,
    fileType: file.fileExtension ?? file.type,
    contentType: file.contentType,
    size: file.size,
    contactDocumentId: file.id,
  };
}
